import { ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./shared";

const stanzas = [
  ["DRIVE \u00B7 RADIANCE", "You set the room's temperature. Choose the setting on purpose."],
  ["RECOVERY \u00B7 TIDE", "You reset in cycles. Wait one night before you reply."],
];

export const ReadFragment = () => (
  <section className="py-16 sm:py-24 bg-[#F2F0EB] text-[#0B0B0C]" data-testid="read-fragment-section">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Chapter label="The Read" />
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <h2 className="h-heavy text-[32px] sm:text-5xl lg:text-6xl leading-[0.95]" data-testid="read-fragment-headline">
              It reads like someone
              <br />
              <span className="text-[#8B8E93]">has been paying attention.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-[#55585E] leading-relaxed max-w-md" data-testid="read-fragment-body">
              Two lines from a real Read. Yours is written from your own
              baseline, how you start, how you recover and how you land, and
              arrives with your code.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <button
              onClick={() => document.getElementById("secure")?.scrollIntoView({ behavior: "smooth" })}
              className="group mt-8 inline-flex items-center gap-2 text-[#FF4D0A] font-mono-brand text-xs font-bold tracking-[2px] uppercase hover:opacity-80 transition-opacity"
              data-testid="read-fragment-cta"
            >
              Get my Read free
              <ArrowRight size={13} className="transition-transform group-hover:translate-x-0.5" />
            </button>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-6">
          <div className="bg-[#0B0B0C] p-7 sm:p-10 space-y-8" data-testid="read-fragment-card">
            {stanzas.map(([label, line]) => (
              <div key={label}>
                <p className="font-mono-brand text-[10px] tracking-[0.3em] text-[#FF4D0A] mb-3">{label}</p>
                <p className="text-[#F2F0EB] text-lg sm:text-xl leading-relaxed font-display font-bold">{line}</p>
              </div>
            ))}
            <p className="font-mono-brand text-[9px] tracking-[0.25em] uppercase text-[#6E7178] pt-2 border-t border-[#F2F0EB]/10">
              From one person's Read. Yours will not say this.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
